import React from "react";
import AwardSummaryTable from "./AwardSummaryTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const AwardSummaryIndex = () => (
  <ReportProgramsPage
    TableComponent={AwardSummaryTable}
    loadingMessage="Loading award summary..."
  />
);

export default AwardSummaryIndex;
